import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import {
  CommentNodeTextType,
  FlowChartCommentNode,
} from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartCommentNode'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { NodeType } from 'common/builder/constants/NodeType'
import { ICommentNode } from 'common/builder/nodes/nodeInterfaces'
import { URL_RULE_REGEX } from 'constants/RegExs'

export const CommentNodeGenericConverterRule: ConverterRule<
  ICommentNode,
  FlowChartCommentNode,
  NodeConverterRulePayload
> = {
  predicate(entity: ICommentNode): boolean {
    return entity?.nodeType === NodeType.COMMENT
  },

  convert(entity) {
    const textArray = entity.text
      .split(URL_RULE_REGEX)
      .filter(Boolean)
      .map((textPart) => ({
        type: textPart.match(URL_RULE_REGEX) ? CommentNodeTextType.URL : CommentNodeTextType.TEXT,
        value: textPart,
      }))

    return {
      id: entity.id,
      onboardingElementId: '',
      type: FlowChartNodeType.COMMENT,
      nodeType: NodeType.COMMENT,
      data: {
        text: textArray,
        fontSize: entity.fontSize,
        nodeSize: entity.nodeSize,
      },
    }
  },
}
